/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import React from 'react';
import { Box } from '@mui/material';
import styled from 'styled-components';
import appTheme from '../common/theme/appTheme.json';

export const PROVISIONING_HEADER_HEIGHT = 72;
const ProvisioningHeader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: `${PROVISIONING_HEADER_HEIGHT}px`,
        alignItems: 'center',
        position: 'relative',
        backgroundColor: appTheme.primaryBackgroundColor,
      }}
    >
      <StyledProvisioningHeading>Provisioning</StyledProvisioningHeading>
    </Box>
  );
};

const StyledProvisioningHeading = styled.h1`
  font-family: ${appTheme.viasatFontFamilyHeavy};
  color: ${appTheme.primaryTextColor};
  font-weight: 800;
  font-size: 32px;
  padding-left: 16px;
  letter-spacing: 0.2px;
  line-height: 40px;
`;
export default ProvisioningHeader;
